import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

export const Contact = () => {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_26mjd7s", "template_zc2yp6f", formRef.current, {
        publicKey: "dnNxT80S7LgNjPBCG",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          alert("Message sent successfully!");
          formRef.current.reset();
        },
        (error) => {
          console.log("FAILED...", error.text);
          alert("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <div id="contact">
      <div className="container">
        <div className="col-md-8">
          <div className="row">
            <div className="section-title">
              <h2>Get In Touch</h2>
              <p>
                Please fill out the form below to send us an email, and we will
                get back to you as soon as possible.
              </p>
            </div>
            <form ref={formRef} onSubmit={sendEmail}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="from_name"
                      className="form-control"
                      placeholder="Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="email"
                      name="from_email"
                      className="form-control"
                      placeholder="Email"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  className="form-control"
                  rows="4"
                  placeholder="Message"
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn btn-custom btn-lg">
                Send Message
              </button>
            </form>
          </div>
        </div>
        <div className="col-md-3 col-md-offset-1 contact-info">
          <div className="contact-item" style={{ color: "white" }}>
            <h3>Contact Info</h3>
            <p>
              <span>
                <i className="fa fa-map-marker"></i> Address
              </span>
              <a
                href="https://g.page/r/CVCQJi4Ezp82EBE/review"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "white" }}
              >
                Rwanda, Kigali, Kicukiro KK730
              </a>
            </p>
          </div>
          <div className="contact-item" style={{ color: "white" }}>
            <p>
              <span>
                <i className="fa fa-phone"></i> Phone
              </span>{" "}
              <a href="tel:+250788310143" style={{ color: "white" }}>
                +250788310143
              </a>
            </p>
          </div>
          <div className="contact-item" style={{ color: "white" }}>
            <p>
              <span>
                <i className="fa fa-envelope"></i> Email
              </span>{" "}
              <a
                href="mailto:ezaservicesgroupltd@gmail.com"
                style={{ color: "white" }}
              >
                ezaservicesgroupltd@gmail.com
              </a>
            </p>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row">
            <div className="social">
              <ul>
                <li>
                  <a
                    href="https://www.linkedin.com/in/eza-services-group-ltd-4542b4354/"
                    target="_blank"
                  >
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="https://x.com/AllySeruhashya" target="_blank">
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/eza_services_group_ltd/"
                    target="_blank"
                  >
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="https://wa.me/0788310143" target="_blank">
                    <i className="fa fa-whatsapp"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p style={{ color: "black" }}>
            &copy; 2025 Eza Group Services Ltd. Design by{" "}
            <a
              href="https://allymutabazi.netlify.app/"
              rel="nofollow"
              style={{ color: "black" }}
            >
              Ally M
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
